import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { languageDirection } from 'src/utils/i18n';

export const AppColors = {
	primary: '#3187fc',
	secondary: '#2c2c2e',
};

function MuiTheme({ children }) {
	const { i18n } = useTranslation();

	const theme = createTheme({
		direction: languageDirection(i18n.language),
		typography: {
			fontSize: 24,
			fontFamily: `peyda, sans-serif`,
		},
		palette: {
			primary: {
				main: AppColors.primary,
			},
			secondary: {
				main: AppColors.secondary,
			},
		},
	});

	return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

export default MuiTheme;
